export default "__VITE_ASSET__CCCiNs9P__"